/* Fransk katalog for locale-inbox-vouchers-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'inbox.inboxWithCount': 'Boîte de réception ({count})',
  'inbox.wordDocuments': 'documents',
  'inbox.wordVouchers': 'justificatifs',
  'inbox.emptyDocsTitle': 'Aucun document',
  'inbox.emptyTrashTitle': 'La corbeille est vide',
  'inbox.emptyDocsText': 'Téléversez ici vos accords, contrats et documents.',
  'inbox.searchDocsFull': 'Rechercher des documents - nom de fichier, type...',
  'inbox.vehicleCostReminderDefault': 'Uniquement si l\'entreprise possède ou loue un véhicule.',
});
